export const timeMachineUrlByType = '/:type(discover|latest)';
export const timeMachineUrlByDex = '/:type(chain)/:chain';
